import { createFileRoute, redirect } from "@tanstack/react-router";

// Retired feature: send old links somewhere useful. Data is kept.
export const Route = createFileRoute("/future-readiness")({
  beforeLoad: () => {
    throw redirect({ to: "/", replace: true, statusCode: 301 });
  },
});
